export default {
  close: 'Закрыть',
  external: 'Открыть в новой вкладке',
}
